// import Vue from 'vue'
import store from '@/store/index'
import {
  Message
} from 'element-ui'
// 按钮权限

// 创建vue自定义指定
const has = Vue.directive('has', {
  // 当被绑定的元素插入到 DOM 中时……
  bind: function (el, binding, vnode) {
    // el 为元素dom binding 为指令中的相关属性

    if (!isLimit(binding.expression)) {
      vnode.elm.disabled = true
      el.className = el.className + ' is-disabled'
      el.Myclick = function (e) {
        Message.error('没有操作权限')
      }
      if (vnode.data.on) {
        vnode.data.on.click.fns = el.Myclick
      }
    }
  },
  update: function (el, binding, vnode) {
    if (!isLimit(binding.expression)) {
      vnode.elm.disabled = true
      el.className = el.className + ' is-disabled'
      el.Myclick = function (e) {
        Message.error('没有操作权限')
      }
      if (vnode.data.on) {
        vnode.data.on.click.fns = el.Myclick
      }
    }
  }
})

// 检查该用户是否拥有 该按钮权限
function isLimit (value) {
  // v-has 时绑定的属性
  // console.log(value, 'value')
  var isExist = null
  store.state.login.menuList.forEach(item => {
    if (item.children) {
      item.children.forEach(item2 => {
        if (item2.children) {
          item2.children.forEach(item3 => {
            // 获取到按钮权限的数组
            // 当按钮拥有权限时 存在数组当中
            if (item3.meta.limitBtn) {
              item3.meta.limitBtn.forEach(data => {
                // 判断与绑定的value是否一致 一致  即拥有权限 return 否无
                if (data === value) {
                  isExist = true
                  return isExist
                }
              })
            }
          })
        }
      })
    }
  })
  return isExist
}

export default has



// WEBPACK FOOTER //
// ./src/utils/limit.js